import React from 'react';
import Modal from '../../../Components/Modal';
import Form, {ULID, TextField, Actions, Services} from '../../../Components/Form';

const EditCategory = ({isOpen, setIsOpen, category, saveCategory}) => {
    const title = (category && category.id) ? 'Edit category' : 'Add category';

    return <Modal isOpen={isOpen} setIsOpen={setIsOpen} title={title} dismissible>
        {isOpen && <Inner {...{category, saveCategory, title}} />}
    </Modal>
}

const Inner = ({category, saveCategory, title}) => {
    category.pricingCategoryId = category.pricingCategoryId ?? category.id ?? null;

    return <Form data={category} onSubmit={saveCategory} closeModalOnSubmit>
        <ULID name="pricingCategoryId" />
        <TextField name="name" label="Name" validators={[]} />
        <TextField name="description" label="Description" validators={[]} />
        <Services name="services" label="Services" validators={[]} />
        <Actions submit={{label: title}} cancel />
    </Form>
}

export default EditCategory;